export interface HeroContent {
  title: string;
  subtitle: string;
  category: string;
  location: string;
  bgImage: string;
  bgVideo?: string;
  trailImages: string[];
}

export const heroData: Record<string, HeroContent> = {
  about: {
    title: "GLOBAL REACH",
    subtitle: "Seamless Supply Chains",
    category: "Worldwide Solutions",
    location: "ASIA • EU • USA",
    bgVideo: "/videos/about-page-video.mp4",
    bgImage:
      "",
    trailImages: [
      "/aboutimages/about1.webp",
      "/aboutimages/about2.webp",
      "/aboutimages/about3.webp",
      "/aboutimages/about4.webp",
    ],
  },

  products: {
    title: "OUR PRODUCTS",
    subtitle: "Engineered For Global Industries",
    category: "Manufacturing Excellence",
    location: "Exported Worldwide",
    bgVideo: "/videos/product-page-video.mp4",
    bgImage:
      "",
    trailImages: [
      "/productimage/mcard1.webp",
      "/productimage/mcard2.webp",
      "/productimage/mcard3.webp",
      "/productimage/mcard4.webp",
    ],
  },

  catalogues: {
    title: "CATALOGUE",
    subtitle: "Explore Our Complete Product Collection",
    category: "Digital & Print Catalogue",
    location: "Available Worldwide",
    bgVideo: "/videos/catelouge-page-video.mp4",
    bgImage:
      "",

    trailImages: [
      "/catelougeimages/ccard1.webp",
      "/catelougeimages/ccard2.webp",
      "/catelougeimages/ccard3.webp",
      "/catelougeimages/ccard4.webp",
    ],
  },

  "ai-builder": {
    title: "AI PRODUCT BUILDER",
    subtitle: "Industrial Standards, Perfect Fit",
    category: "Advanced AI Solutions",
    location: "Global Manufacturing",
    bgVideo: "/videos/catelouge-page-video.mp4",
    bgImage: "",
    trailImages: [
      "/contactimages/fcard1.webp",
      "/contactimages/fcard2.webp",
      "/contactimages/fcard3.webp",
      "/contactimages/fcard4.webp",
    ],
  },

  contact: {
    title: "Contact",
    subtitle: "Gateway To Markets",
    category: "24/7 Support",
    location: "Global Presence",
    bgVideo: "/videos/contact-page-video.mp4",
    bgImage:
      "",
    trailImages: [
      "/contactimages/fcard1.webp",
      "/contactimages/fcard2.webp",
      "/contactimages/fcard3.webp",
      "/contactimages/fcard4.webp",
    ],
  },
};